import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ServerDetailPage } from "@/features/operator/ServerDetailPage";

export const Route = createFileRoute("/app/operator/servers/$serverId")({
  validateSearch: z.object({ tab: z.enum(["overview", "nodes", "tokens"]).optional().catch(undefined) }),
  component: KeyedServerDetail,
});

// Going from one server to another stays on this route: remount so no
// per-server state (move follow-ups, token dialogs) carries over.
function KeyedServerDetail() {
  const { serverId } = Route.useParams();
  return <ServerDetailPage key={serverId} />;
}
